import ky from 'ky'
import { redirect } from 'next/navigation'

function getBffPrefixUrl() {
  if (typeof window !== 'undefined') {
    return '/api/'
  }

  return process.env.NEXT_PUBLIC_BFF_API
}

function handleUnauthorizedResponse() {
  if (typeof window !== 'undefined') {
    window.location.assign('/logout')
    return
  }

  redirect('/logout')
}

export const bff_client = ky.create({
  prefixUrl: getBffPrefixUrl(),
  timeout: false,
  credentials: 'include',
  headers: {
    Cookie: 'service_experiment=zamply',
    'Content-Type': 'application/json',
  },
  hooks: {
    beforeRequest: [],
    afterResponse: [
      (_request, _options, response) => {
        const unauthorizedCode = 401
        if (response.status === unauthorizedCode) {
          handleUnauthorizedResponse()
        }
      },
    ],
  },
})
